import { render, staticRenderFns } from "./TabsExpansionPanel.vue?vue&type=template&id=1e51f8e6&scoped=true&"
import script from "./TabsExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./TabsExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./TabsExpansionPanel.vue?vue&type=style&index=0&id=1e51f8e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51f8e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VTab,VTabs})
